<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-default opacity-8"></span>
      <!-- Header container -->
      <div
        class="container-fluid d-flex align-items-center vld-parent"
        ref="cursos_list"
      >
        <div class="row">
          <div class="col-12 d-block d-md-none">
            <router-link
              :to="'/'"
              class="btn-link font-weight-normal text-white"
              title="Voltar para o início"
              ><i class="fas fa-chevron-left mr-1"></i> Voltar</router-link
            >
          </div>
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-3 mb-5">
              Aqui você encontra cursos com contéudo de alto nível para sua
              startup. Para garantir materiais de alta qualidade, os módulos
              passaram por curadoria da Stars Aceleradora e da incubadora.
              Lembre-se de dar seu feedback e, quando disponível, responder as
              perguntas de avaliação.
            </p>
          </div>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--7">
      <div v-if="empty" class="row">
        <div class="col-12 text-center">
          <badge type="info" class="bg-white">
            Nenhum curso disponível na trilha de capacitação até o momento para
            seu perfil
          </badge>
        </div>
      </div>
      <div v-else>
        <div class="row">
          <div class="col-12">
            <div class="card-deck">
              <div
                class="col-lg-4 col-md-6 mb-5 d-flex align-items-stretch"
                v-for="curso in cursos"
                :key="curso.user_id"
              >
                <div class="card flex-grow-1 border-0">
                  <div class="card-image">
                    <img
                      class="card-img-top rounded-top"
                      :src="curso.image_url || placeholderImg"
                      alt="Imagem curso"
                    />
                    <div class="image-overlay"></div>
                  </div>
                  <div class="card-body py-3">
                    <h2 class="card-title mb-1">{{ curso.title }}</h2>
                    <p class="description mb-0">{{ curso.subtitle }}</p>
                    <p class="card-text mt-2 mb-0" v-if="curso.description">
                      <span :title="curso.description">{{
                        truncate(curso.description)
                      }}</span>
                    </p>
                  </div>
                  <div class="card-footer text-center">
                    <div class="row">
                      <div class="col-12 text-center">
                        <span class="completion mr-2 text-sm">
                          {{
                            curso.completation > 0
                              ? `${curso.completation}% completo`
                              : "Curso não iniciado"
                          }}
                        </span>
                        <base-progress
                          :type="getProgressType(curso.completation)"
                          :show-percentage="false"
                          :striped="true"
                          :animated="true"
                          class="pt-0"
                          :value="curso.completation"
                        />
                      </div>
                      <div class="col-12">
                        <router-link
                          :to="
                            '/startup/trilha/cursos/' + curso.id + '/visualizar'
                          "
                          class="btn btn-white"
                          v-tooltip="
                            'Clique para abrir o curso e ver os materiais'
                          "
                          ><i class="fas fa-book text-dark-green mr-2"></i>Abrir
                          curso</router-link
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-muted text-right mt-3">
            <b>{{ cursos.length }}</b> cursos de capacitação liberados
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/services/api";

export default {
  name: "trilha",
  data() {
    return {
      cursos: [],
      empty: false,
      placeholderImg: "/img/pages/default_banner_course.jpg",
    };
  },
  async mounted() {
    let loader = this.$loading.show({
      container: this.$refs.cursos_list,
      width: 150,
      height: 150,
      opacity: 0,
    });
    try {
      const { data } = await api.get("/startup/courses");
      if (data.length) {
        this.cursos = data;
        this.cursos.forEach((course) => {
          course.completation = this.getCompletationPercetange(course);
        });
      } else this.empty = true;
      loader.hide();
    } catch (e) {
      this.$toasted.error("Ocorreu um erro ao recuperar os módulos da trilha");
    }
  },
  methods: {
    truncate(text, stop = 150, clamp = "...") {
      if (!text) return "N/A";
      return text.slice(0, stop) + (stop < text.length ? clamp : "");
    },
    getCompletationPercetange(course) {
      if (!course.__meta__.material_count || !course.viewed) return 0;
      return Number(
        ((course.viewed / course.__meta__.material_count) * 100).toFixed(2)
      );
    },
    getProgressType(completation) {
      if (completation <= 15.0) return "danger";
      if (completation <= 30.0) return "warning";
      if (completation <= 45.0) return "default";
      if (completation <= 60.0) return "info";
      if (completation < 100.0) return "primary";
      return "success";
    },
  },
};
</script>
<style scoped>
.card-img-top {
  height: 200px;
  margin: auto;
  object-fit: cover;
}

.card-image {
  position: relative;
  height: 200px;
}

.image-overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  opacity: 0.2;
  transition: 0.5s ease;
  background: rgba(0, 0, 0, 0.5);
}

.card:hover .image-overlay {
  opacity: 1;
}
</style>
